import { render, staticRenderFns } from "./TmbLogin.vue?vue&type=template&id=61a2faea&"
import script from "./TmbLogin.vue?vue&type=script&lang=js&"
export * from "./TmbLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports